// @ts-nocheck
import { Trans, useLingui } from '@lingui/react'
import { type FC } from 'react'

import { DOCUMENT_TYPE, PRESCRIPTION_TYPES, SA_SELLER_ID } from 'shared/consts'
import type {
  CartControllerGroupEntryV2,
  CartControllerSellerGroupV2,
} from 'types/api/cart'
import Price from 'views/components/atoms/Price'
import { formatPriceStringStoreConnected } from 'views/components/atoms/Price/helpers'
import TransWithHtml from 'views/components/utils/TransWithHtml'

type Props = {
  showTotalAmountPrescriptionBonusToAccount: boolean
  rxCreditNoteAmount: number
  rxBonusToAccount: number
  currency: string
  sellerGroups: Array<CartControllerSellerGroupV2>
}

const CreditNote: FC<Props> = ({
  showTotalAmountPrescriptionBonusToAccount,
  rxCreditNoteAmount,
  rxBonusToAccount,
  currency,
  sellerGroups,
}) => {
  const { i18n } = useLingui()
  const formattedBonusToAccount = formatPriceStringStoreConnected({
    amount: rxBonusToAccount,
    currency,
  })

  const hasMarketplaceProducts = sellerGroups?.find(
    (sg: CartControllerSellerGroupV2) => sg.sellerId !== SA_SELLER_ID
  )
  const saeSellerGroup = sellerGroups?.find(
    (sg: CartControllerSellerGroupV2) => {
      return sg.sellerId === SA_SELLER_ID
    }
  )

  const groupEntriesWithPrescriptions =
    saeSellerGroup?.groupEntries.find((ssg: CartControllerGroupEntryV2) => {
      return PRESCRIPTION_TYPES.includes(ssg.type)
    })?.items?.length > 0 || false

  const groupEntriesWithoutPrescriptions =
    saeSellerGroup?.groupEntries.find((ssg: CartControllerGroupEntryV2) => {
      return ssg.type === DOCUMENT_TYPE.NO_PRESCRIPTION
    })?.items.length > 0 || false

  /*
  There is case where ODC, RX and MP product is in cart, in that case we need to check all products to see if rxOtcMpNote should be shown
  */
  const shouldShowMarketplaceBonusNote =
    hasMarketplaceProducts &&
    groupEntriesWithPrescriptions &&
    groupEntriesWithoutPrescriptions

  return (
    (Boolean(rxCreditNoteAmount) || Boolean(rxBonusToAccount)) && (
      <div className="u-border--top o-CartSumBox__CreditNote">
        <p
          data-qa-id="cart-sumBox-rxCreditNote"
          className="u-margin-large--bottom u-margin-large--top o-CartSumBox__CreditNote__inner"
        >
          {shouldShowMarketplaceBonusNote ? (
            <TransWithHtml text={i18n._('general.cartSumBox.rxOtcMpNote')} />
          ) : (
            <>
              {Boolean(rxCreditNoteAmount) && (
                <Trans
                  id="general.cartSumBox.rxCreditNote"
                  values={{
                    value: (
                      <Price amount={rxCreditNoteAmount} currency={currency} />
                    ),
                  }}
                />
              )}
              {Boolean(rxBonusToAccount) &&
                !showTotalAmountPrescriptionBonusToAccount && (
                  <Trans
                    id="general.cartSumBox.rxCreditNote"
                    components={{
                      b: <span className="u-font-weight--semi-bold" />,
                    }}
                    values={{
                      value: (
                        <Price amount={rxBonusToAccount} currency={currency} />
                      ),
                    }}
                  />
                )}
              {Boolean(rxBonusToAccount) &&
                showTotalAmountPrescriptionBonusToAccount && (
                  <TransWithHtml
                    text={i18n._(
                      'account.orders.details.payment.bonusAnnouncement',
                      { bonus: formattedBonusToAccount, superscript: 7 }
                    )}
                  />
                )}
            </>
          )}
        </p>
      </div>
    )
  )
}

export default CreditNote
